import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { VaService } from '../../_services/va.service'
import { NotificationService, NotificationType } from '../../_services/notification.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reset-va-password',
  templateUrl: './reset-va-password.component.html',
  styleUrls: ['./reset-va-password.component.scss']
})


export class ResetVaPasswordComponent implements OnInit {

  signUpForm = new FormGroup({
    password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(40)])
  });
  public agent_id: any;
  public user_id: any;
  public passwordNotMatch: any = "";
  public passwordShow: any;
  public confirmPasswordShow: any;
  public region: any = "VA"
  public formSubmitted: any = false; 
  public tokenValid: any = "validating"; 
  environment_prod_url: any =""
  dashboard_lite_url: any = "";
  dashboard_url: any = "";
  dashboard_redirect_url: any;



  constructor(
    private route: ActivatedRoute,
    private _vaService: VaService,
    private _notificationService: NotificationService) { }


  ngOnInit() {
    if(this.route.snapshot.data.region == 'dashboard'){
      this.region = "Dashboard"
    }
    this.route.params.subscribe(params => {
      this.agent_id = params['agent_id'];
      this.user_id = params['id'];
    });
    this.environment_prod_url = environment.webcomponent_prod_base_url + this.agent_id;
    this.dashboard_lite_url = environment.base_dashboard_lite_url + this.agent_id+'/?fs=true'
    this.dashboard_url = environment.base_dashboard_url + this.agent_id + '?fs=true'
    this.getAgentDetails();
    const params = {'region': this.region};
    this._vaService.validateToken(this.agent_id, params, this.user_id).subscribe((result) => {
      this.tokenValid = true
    }, (error) => {
      if (error.status == 400) {
        this.tokenValid = false
      }
    })
  }

  getAgentDetails() {
    this._vaService.getAgent(this.agent_id).subscribe((result) => {
      if(result["dashboard_type"] == "dashboard"){
        this.dashboard_redirect_url = this.dashboard_url;
      } else {
        this.dashboard_redirect_url = this.dashboard_lite_url;
      }
    }, (error) => {
      if (error.status == 400) {
        this.tokenValid = false
      }
    })
  }

  
  reset_va() {
    var value = this.signUpForm.value

    if (value["password"] != value["confirmPassword"]) {
      this.passwordNotMatch = "error"
    } else {
      this.passwordNotMatch = "success"
      const params = { 'password': this.signUpForm.get('password').value, 'token': this.user_id };
      
      let notificationID = this._notificationService.showNotification({
        message: "Checking..",
        type: NotificationType.info,
        isLoading: true
      })
      this._notificationService.notificationID.push(notificationID);

      this._vaService.resetVApassword(this.agent_id, params, this.user_id).subscribe((result) => {
        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
        this.signUpForm.reset();
        this.formSubmitted = true;
      }, (error) => {
        if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
          let notifyID = this._notificationService.notificationID.shift();
          this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
        }
      })

    }


  }

}
